import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class ProductContributorModel extends Model {
  @attr('number') position;

  // Relation
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('category', { async: true, inverse: null }) category;
  @belongsTo('product', { async: true, inverse: 'contributors' }) product;
}
